<template>
<w-sliding-popup class="automap-schedule-setting-popup" ref="schedulePopup" :title="title" width="700px" @close="onClosePopup">
  <el-form slot="content" label-position="top" :model="scheduleData" ref="scheduleForm" :rules="rules">
    <div class="title-bar title-h4 dot-title">수집 주기 정보</div>
    <div class="mr-b25">
      <el-form-item label="스케줄 명" prop="scheduleName">
        <el-input v-model="scheduleData.scheduleName" />
      </el-form-item>
    </div>
    <div class="title-bar title-h4 dot-title">주기 설정</div>
    <w-period-setting-component class="mr-b25" ref="periodSettingCmp" />
    <!-- 스크립트 수행 -->
    <div v-show="showTemplate">
      <div class="title-bar title-h4 dot-title">스크립트 템플릿</div>
      <el-form-item prop="templateId">
        <el-select v-model="scheduleData.templateId">
          <el-option v-for="template in templateList" :key="template.templateId" :label="template.templateName" :value="template.templateId" />
        </el-select>
      </el-form-item>
    </div>
    <!-- IP대역 검색 -->
    <div class="mr-b25" v-show="showScanId">
      <div class="title-bar">
        <span class="title-h4 dot-title mr-r4">수집 주기 정보</span>
        <span class="info-text text-small"> ※ 한 개의 IP대역당 한 개의 스케줄만 설정이 가능합니다.</span>
      </div>
      <el-form-item prop="scanId">
        <el-select v-model="scheduleData.scanId" placeholder="설정 가능한 IP대역이 없습니다.">
          <el-option v-for="scan in scanList" :key="scan.scanId" :label="scan.scanName" :value="scan.scanId" />
        </el-select>
      </el-form-item>
      <div class="title-bar title-h4 dot-title">수집 서버</div>
      <el-form-item prop="agentManagerId">
        <el-select v-model="scheduleData.agentManagerId">
          <el-option v-for="agent in agentList" :key="agent.agentManagerId" :label="agent.agentManagerName" :value="agent.agentManagerId" />
        </el-select>
      </el-form-item>
    </div>
    <!-- 정책감사수행 제외 모든탭 -->
    <div v-show="showTarget">
      <w-common-obj-list ref="commonObjList" type="physical" selected-managetype-id="NMS" :load-obj-list="true" :load-params="loadParams" :active="active">
        <div slot="title" class="title-h4 dot-title">
          수집 대상 선택
        </div>
      </w-common-obj-list>
    </div>
    <!-- 정책감사수행 -->
    <div v-show="showPolicyAudit">
      <div class="title-bar title-h4 dot-title">보안 정책 선택</div>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="벤더 선택" prop="objCompanyId">
            <el-select @change="onChangeVendorSelect" style="width: 100%;" v-model="scheduleData.objCompanyId">
              <el-option v-for="item in vendorList" :key="item.objCompanyId" :label="item.objCompanyName" :value="item.objCompanyId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item prop="policyId">
            <span slot="label">
                 보안정책
                 <el-tooltip effect="dark" content="스케쥴로 등록되지 않은 보안 정책만 조회됩니다." placement="bottom">
                   <i class="fas fa-info-circle c-pointer"></i>
                 </el-tooltip>
              </span>
            <span>
                <el-select style="width: 100%;" v-model="scheduleData.policyId">
                  <el-option v-for="item in vendorPolicyList" :key="item.policyId" :label="item.policyDescr" :value="item.policyId"></el-option>
                </el-select>
              </span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <div class="mr-b25" v-show="showAutotopology">
      <w-autotopology-setting-form :schedule-data="scheduleData" type="topology" ref="autotopologySettingCmp"/>
    </div>
  </el-form>
  <el-row slot="footer" type="flex" justify="center">
    <el-button class="mr-r4" type="solid" size="large" @click="onClickSaveButton">저장</el-button>
    <el-button size="large" @click="onClosePopup">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import { isNil, map, clone, differenceWith, isEmpty as objectIsEmpty } from 'lodash';
import NetdeviceCommonAPI from '@/api/common/netdevice';
import ScheduleAPI from '@/api/settings/netdevice/schedule';
import { EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { isEmpty } from '@/utils/basic';
import msgUtil from '@/utils/message';
import WPeriodSettingComponent from '@/views/settings/components/PeriodSettingComponent';
import WCommonObjList from '@/components/table/CommonObjList';
import WAutotopologySettingForm from '@/views/settings/operation/ScheduleSettings/NetworkScheduleSettings/components/form/AutotopologySettingForm';

export default {
  name: 'WScheduleSettingPopup',
  components: {
    WPeriodSettingComponent,
    WCommonObjList,
    WAutotopologySettingForm,
  },
  props: {
    configSchedule: Object,
    popupType: String,
    showTarget: Boolean,
    scheduleTypeId: String,
  },
  data() {
    return {
      scheduleData: {
        scheduleId: null,
        scheduleName: null,
        templateId: null,
        scanId: null,
        agentManagerId: null,
        objCompanyId: null,
        policyId: null,
      },
      title: '수집 주기 추가',
      searchKeyword: null,
      treeData: {},
      templateList: [],
      scanList: [],
      agentList: [],
      vendorList: [],
      vendorPolicyList: [],
      rules: {
        scheduleName: {
          required: true,
          message: '스케줄 명을 입력하십시오.',
          trigger: 'blur',
        },
        policyId: {
          validator: this.validatePolicy,
          trigger: 'blur',
        },
      },
      active: false,
    };
  },
  computed: {
    showTemplate() {
      return this.scheduleTypeId === 'EXEC_TEMPLATE';
    },
    showScanId() {
      return this.scheduleTypeId === 'IP_SCAN';
    },
    showPolicyAudit() {
      return this.scheduleTypeId === 'CMPL_CHECK';
    },
    loadParams() {
      if (objectIsEmpty(this.scheduleData)) {
        return {};
      }
      const params = {};
      if (!isNil(this.scheduleData.ncmIds)) {
        params.ncmIds = this.scheduleData.ncmIds;
      }
      return params;
    },
    showAutotopology() {
      return this.scheduleTypeId === 'AUTO_TOPOLOGY';
    },
  },
  mounted() {
    NetdeviceCommonAPI.getProvidedCompanyList().then((res) => {
      if (res.data.success) {
        this.vendorList = res.data.data;
      }
    });
  },
  watch: {
    searchKeyword(keyword) {
      this.$refs.targetTree.getTree().filter(keyword);
    },
    popupType(type) {
      if (type === 'add') {
        this.title = '수집 주기 추가';
      } else if (type === 'edit') {
        this.title = '수집 주기 편집';
      }
    },
    configSchedule(data) {
      this.scheduleData = clone(data);
      if (objectIsEmpty(data)) {
        return;
      }
      this.$nextTick(() => {
        this.$refs.periodSettingCmp.setPeriodSettingData(data);
      });
    },
  },
  methods: {
    /**
     * 수집 주기 팝업창을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    open() {
      this.scheduleData = {
        scheduleId: null,
        scheduleName: null,
        templateId: null,
        scanId: null,
        agentManagerId: null,
        objCompanyId: null,
        policyId: null,
      };
      this.active = true;
      // 정책 수행 감사
      this.$nextTick(() => {
        if (this.showPolicyAudit) {
          if (this.popupType === 'add') {
            this.$refs.scheduleForm.clearValidate();
            new Promise((resolve) => {
              this.onChangeVendorSelect(this.vendorList[0].objCompanyId);
              resolve();
            }).then(() => {
              this.scheduleData.objCompanyId = this.vendorList[0].objCompanyId;
              // this.scheduleData.policyId = 'NONE';
            });
          } else if (this.popupType === 'edit') {
            new Promise((resolve) => {
              this.onChangeVendorSelect(this.configSchedule.objCompanyId, false);
              resolve();
            }).then(() => {
              this.scheduleData.scheduleId = this.configSchedule.scheduleId;
              this.scheduleData.scheduleName = this.configSchedule.scheduleName;
              this.scheduleData.objCompanyId = this.configSchedule.objCompanyId;
              this.scheduleData.policyId = this.configSchedule.policyId;
            });
          }
        } else if (this.popupType === 'edit' && this.scheduleTypeId === 'AUTO_TOPOLOGY') {
          this.$refs.autotopologySettingCmp.loadData(this.configSchedule.scheduleId);
        }
      });

      // 스크립트 템플릿 조회
      if (this.showTemplate) {
        ScheduleAPI.getScriptTemplate()
          .then((response) => {
            if (response.data.success) {
              const result = response.data.data;
              this.templateList = result;
              if (isEmpty(this.scheduleData.templateId) && !isEmpty(result)) {
                this.scheduleData.templateId = result[0].templateId;
              }
            } else {
              this.templateList = [];
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '스크립트 템플릿', false));
            }
          })
          .catch(() => {
            this.templateList = [];
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '스크립트 템플릿', false));
          });
      }

      if (this.showScanId) {
        // 스캔 아이디 조회
        // : scheduleData 바인딩 된 후 호출 해야하므로 nextTick사용
        this.$nextTick(() => {
          const scheduleId = this.scheduleData.scheduleId;

          ScheduleAPI.getScanId({
            scheduleId: isEmpty(scheduleId) ? null : scheduleId,
          })
            .then((response) => {
              if (response.data.success) {
                const result = response.data.data;
                this.scanList = result;

                if (isEmpty(scheduleId) && !isEmpty(result)) {
                  this.scheduleData.scanId = result[0].scanId;
                }
              } else {
                this.scanList = [];
                this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '스캔 아이디', false));
              }
            })
            .catch(() => {
              this.scanList = [];
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '스캔 아이디', false));
            });
        });

        // 수집 서버 조회
        ScheduleAPI.getAgentMgrList()
          .then((response) => {
            if (response.data.success) {
              const result = response.data.data;
              this.agentList = result;

              if (isEmpty(this.scheduleData.agentManagerId) && !isEmpty(result)) {
                const agentManagerId = result[0].agentManagerId;
                this.scheduleData.agentManagerId = agentManagerId;

                const commonObjList = this.$refs.commonObjList;
                // targetTree.setTreeParams({
                //   managetypeId: 'NMS',
                //   agentManagerId,
                // });
                commonObjList.loadData();
              }
            } else {
              this.agentList = [];
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '수집 서버', false));
            }
          })
          .catch(() => {
            this.agentList = [];
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '수집 서버', false));
          });
      } else if (this.showTarget && !isEmpty(this.$refs.commonObjList)) {
        // 수집 대상 트리 로드
        this.$refs.commonObjList.loadData();
      }
      this.$refs.schedulePopup.visible = true;
    },
    /**
     * 수집 주기 팝업창을 닫는다.
     * @return {[type]} [description]
     * @author jda
     */
    onClosePopup() {
      this.active = false;
      this.reset();
      this.$refs.schedulePopup.visible = false;
    },
    /**
     * 수집 주기 정보를 저장한다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickSaveButton() {
      this.$refs.scheduleForm.validate().then(() => {
        const originalScheduleData = this.scheduleData;

        // 주기설정 데이터
        const data = this.$refs.periodSettingCmp.getPeriodSettingData();
        const params = Object.assign(data, {
          scheduleTypeId: this.scheduleTypeId,
          scheduleContent: this.createScheduleContent(data),
        });

        // 스캔아이디 유효성 검사
        if (this.showScanId && isEmpty(originalScheduleData.scanId)) {
          return;
        }

        // 수집 대상
        if (this.showTarget) {
          const checkedTarget = this.$refs.commonObjList.getSelectedObjList();
          const ncmIds = map(checkedTarget, 'ncmId');

          if (checkedTarget.length < 1) {
            this.$message(msgUtil.getCustomMsgData('대상을 선택해주세요.'));
            return;
          }
          Object.assign(params, {
            ncmIds,
          });

          if (this.scheduleTypeId === 'IP_SCAN') {
            const objIds = this.$refs.commonObjList.getSelectedObjList(true);
            Object.assign(params, {
              objIds: objIds.toString(),
            });
          }
        }
        // 연결정보 수집일 경우
        if (this.scheduleTypeId === 'AUTO_TOPOLOGY') {
          if (this.$refs.autotopologySettingCmp.checkedIp.length < 1) {
            this.$message(msgUtil.getCustomMsgData('IP대역을 선택해주세요.'));
            return;
          }

          if (this.$refs.autotopologySettingCmp.checkedModeling.length < 1) {
            this.$message(msgUtil.getCustomMsgData('모델링 방식을 선택해주세요.'));
            return;
          }

          const autotopologySettingData = this.$refs.autotopologySettingCmp.getAutotopologySettingData(this.popupType);
          Object.assign(params, autotopologySettingData);
        }

        const target = '수집 주기';
        if (this.popupType === 'add') {
          const action = msgUtil.action.ADD;
          ScheduleAPI.addNedeviceSchedule(Object.assign(params, originalScheduleData))
            .then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('loadData');
                this.onClosePopup();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            })
            .catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            })
            .finally(() => {
              if (this.scheduleTypeId === 'AUTO_TOPOLOGY') {
                this.$mapEventBus.$emit('tree_load');
              }
            });
        } else {
          // 주기가 다를 경우 기존 주기 설정 값은 null로 셋팅
          if (originalScheduleData.schedulePeriod !== params.schedulePeriod) {
            const deletedKeys = this.$refs.periodSettingCmp.getKeysByPeriod(originalScheduleData.schedulePeriod);
            deletedKeys.forEach((key) => {
              originalScheduleData[key] = null;
            });
          }
          const deletedNcmIds = differenceWith(originalScheduleData.ncmIds, params.ncmIds);
          const addedNcmIds = differenceWith(params.ncmIds, originalScheduleData.ncmIds);

          const action = msgUtil.action.SAVE;
          ScheduleAPI.updateNetdeviceSchedule(
            Object.assign({}, originalScheduleData, params, {
              deletedNcmIds,
              addedNcmIds,
            }),
          )
            .then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('loadData');
                console.debug('complete test');
                this.onClosePopup();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            })
            .catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            })
            .finally(() => {
              if (this.scheduleTypeId === 'AUTO_TOPOLOGY') {
                this.$mapEventBus.$emit('tree_load');
              }
            });
        }
      }).catch(() => {
        this.$message(msgUtil.getCustomMsgData('값을 설정해주십시오.'));
      });
    },
    /**
     * 스케쥴 상세내용
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    createScheduleContent(record) {
      let scheduleContent;
      switch (record.schedulePeriod) {
        case 'N':
          scheduleContent = `${getDateToString(record.scheduleStarttime, 'YYYY년 MM월 DD일 HH:mm')}수행`;
          break;
        case 'D': {
          let hourInfo = record.scheduleHour;
          let minInfo = record.scheduleMinute;
          if (record.scheduleHour < 10) {
            hourInfo = `0${record.scheduleHour}`;
          }
          if (record.scheduleMinute < 10) {
            minInfo = `0${record.scheduleMinute}`;
          }
          scheduleContent = `매일 ${hourInfo} : ${minInfo}마다 수행`;
          break;
        }
        case 'W': {
          const days = ['일', '월', '화', '수', '목', '금', '토'];

          let intervalDate;
          record.scheduleIntervalDate.split(',').forEach((date) => {
            if (isEmpty(intervalDate)) {
              intervalDate = days[parseInt(date, 10) - 1];
            } else {
              intervalDate += `, ${days[parseInt(date, 10) - 1]}`;
            }
          });
          let hourInfo = record.scheduleHour;
          let minInfo = record.scheduleMinute;
          if (record.scheduleHour < 10) {
            hourInfo = `0${record.scheduleHour}`;
          }
          if (record.scheduleMinute < 10) {
            minInfo = `0${record.scheduleMinute}`;
          }
          scheduleContent = `매주 ${intervalDate}요일 ${hourInfo} : ${minInfo}마다 수행`;
          break;
        }
        case 'M': {
          let hourInfo = record.scheduleHour;
          let minInfo = record.scheduleMinute;
          if (record.scheduleHour < 10) {
            hourInfo = `0${record.scheduleHour}`;
          }
          if (record.scheduleMinute < 10) {
            minInfo = `0${record.scheduleMinute}`;
          }
          scheduleContent = `매 ${record.scheduleIntervalMonth}월 ${record.scheduleIntervalDate}일에 ${hourInfo} : ${minInfo}마다 수행`;
          break;
        }
        default:
          scheduleContent = EMPTY_TEXT;
          break;
      }

      return scheduleContent;
    },
    /**
     * 팝업창을 초기화한다.
     * @author jda
     */
    reset() {
      this.$emit('resetScheduleData');
      this.$refs.scheduleForm.resetFields();
      if (!isEmpty(this.$refs.periodSettingCmp)) {
        this.$refs.periodSettingCmp.init();
      }
      if (!isEmpty(this.$refs.autotopologySettingCmp)) {
        this.$refs.autotopologySettingCmp.init();
      }
    },
    // 공통 논리그룹 체크트리 공통 컴포넌트(WCommonObjList) 적용
    // /**
    //  * 수집 서버 선택시 마다 물리그룹 트리를 재로드한다.
    //  * @param  {[type]} agentManagerId [description]
    //  * @return {[type]}                [description]
    //  * @author jda
    //  */
    // onChangeAgent(agentManagerId) {
    //   const targetTree = this.$refs.targetTree;
    //   targetTree.setTreeParams({
    //     managetypeId: 'NMS',
    //     agentManagerId,
    //   });
    //   targetTree.loadData();
    // },
    onChangeVendorSelect(payload) {
      // 선택한 벤더의 정책위반 정보를 조회한다. 스케줄 설정이 없는 정책만 조회한다.
      ScheduleAPI.getNetdeviceViolationRules({
        objCompanyId: payload,
        policyScheduleFlag: 1,
      }).then((res) => {
        if (res.data.success) {
          if (this.popupType === 'add') {
            this.vendorPolicyList = res.data.data;
          } else {
            const policyList = res.data.data;
            if (!isEmpty(policyList) && policyList.findIndex((item) => item.policyId === this.configSchedule.policyId) < 0) {
              this.vendorPolicyList.unshift({
                policyId: this.configSchedule.policyId,
                policyDescr: this.configSchedule.policyDescr,
              });
            } else {
              policyList.push({
                policyId: this.configSchedule.policyId,
                policyDescr: this.configSchedule.policyDescr,
              });
            }
            this.vendorPolicyList = policyList;
          }
        }
      });
    },
    /**
     * 수집 대상 검색
     * @param  {[type]} keyword [description]
     * @return {[type]}         [description]
     * @author jda
     */
    onSearchPhysicalTree(keyword) {
      this.$refs.targetTree.filterTree(keyword);
    },
    /**
     * 보안 정책 validator
     * @author Ju
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validatePolicy(rule, value, callback) {
      if (this.showPolicyAudit && (isNil(value) || value === '')) {
        callback(new Error('보안 정책을 선택해주십시오.'));
      } else {
        callback();
      }
    },
  },
};
</script>

<style lang="scss">
// .automap-schedule-setting-popup {
//   .el-steps {
//     margin-bottom: 10px !important;
//     padding: 15px 4% 10px !important;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/popup/AutomapScheduleSettingPopup.vue